<br>

<app-settings-data-table [data]="dataSource" [columns]="columns" [displayedColumns]="displayedColumns"
  [actions]="actions" sortActive=""></app-settings-data-table>